/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1SerievideoVideoidLangsAvailableLanguagesQueryResponse,
  GetApiV1SerievideoVideoidLangsAvailableLanguagesPathParams,
  GetApiV1SerievideoVideoidLangsAvailableLanguagesQueryParams,
  GetApiV1SerievideoVideoidLangsAvailableLanguages401,
  GetApiV1SerievideoVideoidLangsAvailableLanguages404,
  GetApiV1SerievideoVideoidLangsAvailableLanguages500,
} from "../../types/serieVideoIdiomasController/GetApiV1SerievideoVideoidLangsAvailableLanguages.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1SerievideoVideoidLangsAvailableLanguages } from "../../clients/serieVideoIdiomasController/getApiV1SerievideoVideoidLangsAvailableLanguages.ts";

export const getApiV1SerievideoVideoidLangsAvailableLanguagesQueryKey = (
  videoId: GetApiV1SerievideoVideoidLangsAvailableLanguagesPathParams["videoId"],
  params?: GetApiV1SerievideoVideoidLangsAvailableLanguagesQueryParams,
) =>
  [
    {
      url: "/api/v1/serievideo/:videoId/langs/available-languages",
      params: { videoId: videoId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1SerievideoVideoidLangsAvailableLanguagesQueryKey =
  ReturnType<typeof getApiV1SerievideoVideoidLangsAvailableLanguagesQueryKey>;

export function getApiV1SerievideoVideoidLangsAvailableLanguagesQueryOptions(
  videoId: GetApiV1SerievideoVideoidLangsAvailableLanguagesPathParams["videoId"],
  params?: GetApiV1SerievideoVideoidLangsAvailableLanguagesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1SerievideoVideoidLangsAvailableLanguagesQueryKey(
    videoId,
    params,
  );
  return queryOptions<
    GetApiV1SerievideoVideoidLangsAvailableLanguagesQueryResponse,
    ResponseErrorConfig<
      | GetApiV1SerievideoVideoidLangsAvailableLanguages401
      | GetApiV1SerievideoVideoidLangsAvailableLanguages404
      | GetApiV1SerievideoVideoidLangsAvailableLanguages500
    >,
    GetApiV1SerievideoVideoidLangsAvailableLanguagesQueryResponse,
    typeof queryKey
  >({
    enabled: !!videoId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1SerievideoVideoidLangsAvailableLanguages(videoId, params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna os idiomas ainda não cadastrados para o vídeo, para dropdown. **(Requer Authorization para autenticação)**
 * @summary Idiomas disponíveis do vídeo (Requer Authorization para autenticação)
 * {@link /api/v1/serievideo/:videoId/langs/available-languages}
 */
export function useGetApiV1SerievideoVideoidLangsAvailableLanguages<
  TData = GetApiV1SerievideoVideoidLangsAvailableLanguagesQueryResponse,
  TQueryData = GetApiV1SerievideoVideoidLangsAvailableLanguagesQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1SerievideoVideoidLangsAvailableLanguagesQueryKey,
>(
  videoId: GetApiV1SerievideoVideoidLangsAvailableLanguagesPathParams["videoId"],
  params?: GetApiV1SerievideoVideoidLangsAvailableLanguagesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1SerievideoVideoidLangsAvailableLanguagesQueryResponse,
        ResponseErrorConfig<
          | GetApiV1SerievideoVideoidLangsAvailableLanguages401
          | GetApiV1SerievideoVideoidLangsAvailableLanguages404
          | GetApiV1SerievideoVideoidLangsAvailableLanguages500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1SerievideoVideoidLangsAvailableLanguagesQueryKey(videoId, params);

  const query = useQuery(
    {
      ...getApiV1SerievideoVideoidLangsAvailableLanguagesQueryOptions(
        videoId,
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1SerievideoVideoidLangsAvailableLanguages401
      | GetApiV1SerievideoVideoidLangsAvailableLanguages404
      | GetApiV1SerievideoVideoidLangsAvailableLanguages500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
